export const userHashSchema = {
  "@id": { type: "number" },
  expiration_date: { type: "string" },
  user_id: { type: ["number", "null"] },
  hash: { type: "string" },
};
